import * as _ from "lodash";
import * as React from "react";
import { default as TriggerInput, InputMode } from "./TriggerInput";
import DropdownInput from "../DropdownInput";
import { IValueLabel } from "processEditor/model/ITriggerData";

export const TcpTrigger: React.FunctionComponent<TcpTriggerProps> = (props) => {
  return (
    <div>
      <TriggerInput
        existingParameters={props.existingParameters}
        name="listenAddress"
        label={"Address"}
        description="0.0.0.0 for all interfaces, only supports IPv4."
        inputMode={InputMode.text}
        elementId={props.id}
      />
      <TriggerInput
        existingParameters={props.existingParameters}
        name="listenPort"
        label={"Port"}
        inputMode={InputMode.number}
        elementId={props.id}
      />
      <TriggerInput
        existingParameters={props.existingParameters}
        name="allowedIps"
        label={
          "Allowed IPs, Comma separated list of IP addresses or ranges. Only support IPv4."
        }
        description="0.0.0.0/0 for all IPs"
        inputMode={InputMode.text}
        elementId={props.id}
      />
      <TriggerInput
        existingParameters={props.existingParameters}
        name="maxConnections"
        label={"Maximum open connections"}
        description="How many open connections are allowed at the same time."
        minValue={1}
        inputMode={InputMode.number}
        elementId={props.id}
      />
      <TriggerInput
        existingParameters={props.existingParameters}
        name="idleTimeoutSeconds"
        description="0 = infinite. If set, the connection is closed after this time after nothing has been received."
        minValue={0}
        label="Idle timeout in seconds"
        inputMode={InputMode.number}
        elementId={props.id}
      />
      <DropdownInput
        dropdownModel={DataModeOptions}
        elementId={props.id}
        key="dataMode"
        identifier="dataMode"
        label={`Data mode`}
      />
      <DropdownInput
        dropdownModel={EncodingOptions}
        elementId={props.id}
        key="encoding"
        identifier="encoding"
        label={`Encoding`}
      />
      <DropdownInput
        dropdownModel={TerminationEventOptions}
        elementId={props.id}
        key="terminationEvent"
        identifier="terminationEvent"
        label={`Termination event`}
      />
      <TriggerInput
        existingParameters={props.existingParameters}
        name="terminationHexString"
        label={"Hex string for termination sequence"}
        description="Hex string for termination sequence. For example, 0A for LF, 68 65 6C 6C 6F for hello."
        inputMode={InputMode.text}
        elementId={props.id}
      />
    </div>
  );
};

interface TcpTriggerProps {
  id: string;
  existingParameters: TcpTriggerConfig;
}

export interface TcpTriggerConfig {
  listenAddress: string; // IP address, hostname, IpV4 any (0.0.0.0)
  listenPort: number;
  allowedIps: string; // comma separated list of IP addresses or ranges
  maxConnections: number;
  dataMode: DataMode;
  encoding: Encoding;
  terminationEvent: TerminationEvent;
  terminationHexString: string; // hex string for termination sequence eg. 0A
  idleTimeoutSeconds: number; // seconds, < 1 is infinite
}

export enum DataMode {
  Text = "Text",
}

export enum Encoding {
  ASCII = "ASCII",
  UTF8 = "UTF-8",
}

export enum TerminationEvent {
  CharacterSequence = "CharacterSequence",
}

const DataModeOptions: IValueLabel[] = [
  { value: DataMode.Text, label: "Text" },
];

const EncodingOptions: IValueLabel[] = [
  { value: Encoding.ASCII, label: "ASCII" },
  { value: Encoding.UTF8, label: "UTF-8" },
];

const TerminationEventOptions: IValueLabel[] = [
  { value: TerminationEvent.CharacterSequence, label: "Character Sequence" },
];
